import { KYMW6100Model } from '../kymw6100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像ファイルを出力する
 *
 * @export putImageFileService
 * @class PutImageFileService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class PutImageFileService extends PlessJsonResponderSub<any> {

  vo = {
    imageFileNameList: []
  };

  // 処理に使用するModel
  private model: KYMW6100Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
  * bodyにセットする値を返す
  *
  * @private
  * @returns {PlessRequest} リクエストJSON
  * @memberof putImageFileService
  */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        ImageFile: {
          combination: this.vo.imageFileNameList.map(imageFileName => ({
            condition: {
              ImageFileName: imageFileName
            }
          }))
        }
      }
    });
  }

  /**
  * API呼び出し
  *
  * @param model
  * @memberof putImageFileService
  */
  execute(model: KYMW6100Model, vo: any): void {
    this.model = model;
    this.vo = vo;
    this.send('putImageFile', this.getBody());
  }

  /**
  * API通信成功時の処理
  *
  * @param {*} data レスポンスデータ
  * @memberof putImageFileService
  */
  success(data: any): void {
    return;
  }
}
